// extracted by mini-css-extract-plugin
export default {"handGrid":"Hand_handGrid__AC-lV"};